/**
 * OWNER-DAILY-EOD-REPORT-V2 -- the reporting scope parameter + the ONE
 * display formatter pair the Daily/EOD presentation components share.
 *
 * SCOPE ARRIVES AS A PARAMETER (founder ruling 2026-08-19, forward
 * compatibility): no component in this folder knows what "Owner" or "all
 * clinics" means. The caller composes the scope label from whatever lens
 * it is authorised to read, and the components render it. The next
 * role-scope package reuses these components for a doctor's own scope or
 * an AGM's permitted clinics WITHOUT forking the reporting UI -- and
 * WITHOUT this package widening any authorization: P1 constructs a scope
 * only from the Owner-safe truth the existing wire already returns.
 *
 * PRESENTATION-ONLY: nothing here fetches, derives business truth, or
 * decides who may see what. Authorization is server-side, upstream.
 */

/** How the report names the slice of the business it is describing. */
export interface ReportScope {
  /** e.g. "All clinics (3)" or "Banjara Hills" -- composed by the caller. */
  readonly label: string;
  /** e.g. "Today - 19 Aug 2026" -- the period the figures cover. */
  readonly periodLabel: string;
  /** TRUE when the scope is a single clinic; clinic-grain truth (the cash
   *  ledger) is only truthful then. The caller decides, never a component. */
  readonly singleClinic: boolean;
}

/** UNKNOWN is not ZERO: an unresolvable figure prints this, never "0". */
export const REPORT_NO_VALUE = '--';

/** Minor units -> whole-rupee INR label (/100 only at display; money law). */
export function inrMinor(minor: number | null): string {
  if (minor === null) return REPORT_NO_VALUE;
  return `INR ${Math.round(minor / 100).toLocaleString('en-IN')}`;
}

/** Percent label; null (no denominator) prints UNKNOWN, never "0%". */
export function pctLabel(ratePct: number | null): string {
  return ratePct === null ? REPORT_NO_VALUE : `${ratePct}%`;
}
